<template>

<div align="justify">
    <p class="h4" align="center">Сопровождение 1С:ИТС</p>
    <div align="justify" style="padding: 10px;">
        
        <!--
        <p>
            <strong>Описание</strong>
        </p>
        -->
        
        <p>
            Информационно-технологическое сопровождение (1С:ИТС) — это комплексная поддержка,
            которую фирма «1С» совместно со своими партнерами оказывает пользователям программ «1С:Предприятие».
        </p>
        
        <p>
            Компания ООО «АИС» оказывает регулярную и оперативную поддержку пользователей 1С по единому,
            разработанному фирмой «1С», Стандарту регулярного сопровождения 1С.            
        </p>
        
        <!--
        <img src="/img/its.png" alt="ИТС">
        
        <br><br>
        -->
        
        <p>
            
            Заключая Договор комплексного сопровождения, каждый пользователь программ «1С»:<br><br>

            - будет уверен в легальности полученных обновлений программных продуктов фирмы «1С»;<br>
            - получит возможность использовать все знания и опыт, накопленные методистами и экспертами фирмы «1С» в области бухгалтерского учета, налогообложения, кадрового учёта;<br>
            - научиться эффективно работать в программах 1С, максимально используя мощный функционал, заложенный разработчиками в систему «1С:Предприятие»;<br>
            - будет в курсе изменений законодательства и их отражении в программах «1С»;<br>
            - сможет получить персональную консультацию у ведущих экспертов, аудиторов, методистов и разработчиков фирмы «1С» и партнёров;<br>
            - будет получить квалифицированную помощь партнёров по установке, обновлению программ и подключению всех информационных ресурсов фирмы «1С».<br>
            
            <br>
            
            ВАЖНО! В соответствии с правилами лицензионной политики фирмы 1С,
            любое обслуживание пользователей программных продуктов 1С:Предприятие (за исключением базовых версий),
            осуществляется только при заключении Договора на комплексное сопровождение*.<br>
            <br>
            *С тарифами Договоров комплексного сопровождения можно ознакомиться
            <span v-on:click="goToHref(httpPath + '/тарифы');"
                  style="font-weight: bold; text-decoration: underline; color: blue; cursor: pointer;">здесь</span>.
            
        </p>
        
        
    </div>
    
</div>

</template>

<script>
export default {
    name: 'PageContacts',
    data: function(){
        return{
            httpPath: ""
        };
    },
    created: function(){
        
        this.httpPath = this.$store.getters.httpPath;
        
    },
    methods: {
        goToHref: function(href){
            this.$router.push(href);
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
    
</style>

